const styles = (theme) => ({
  paper: {
    padding: { xs: "20px", md: "30px" },
    borderRadius: "16px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  containerHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  header: { display: "flex", alignItems: "center", gap: 1, mb: 2 },
  title: { fontWeight: "bold", fontSize: "20px" },
});

export default styles;
